import React, { useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import './DigilockerLauncher.css';

const DigilockerLauncher = () => {
  const [requestId, setRequestId] = useState(null);
  const [responseData, setResponseData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [polling, setPolling] = useState(false);

  // Replace with actual keys or store in a secure config file/environment variable
const APP_ID = process.env.REACT_APP_BACKEND_APPID;
const API_KEY = process.env.REACT_APP_BACKEND_APIKEY;

  const handleLaunch = async () => {
    try {
      setLoading(true);
      setResponseData(null);

      const res = await axios.post(
        'https://digilocker.myearth.id/api/digilocker/init',
        {
          docs: ['ADHAR'],
          purpose: 'KYC Verification',
          response_url: 'https://digilocker.myearth.id/api/digilocker/webhook',
          redirect_url: 'https://digilock.myearth.id/digilocker-redirect',
          redirect_method: 'GET',
          fast_track: 'Y',
          pinless: true,
        },
        {
          headers: {
            'app-id': APP_ID,
            'x-api-key': API_KEY,
          },
        }
      );

      const { sdk_url, request_id } = res.data;
      setRequestId(request_id);

      // Save request ID to localStorage
      localStorage.removeItem("digilockerRequestId");
      localStorage.setItem("digilockerRequestId", request_id);

      window.open(sdk_url, '_blank');
      pollWebhookResponse(request_id);
    } catch (err) {
      Swal.fire({
        icon: 'error',
        title: 'Failed',
        text: 'Failed to initialize Digilocker. Please try again.',
      });
    } finally {
      setLoading(false);
    }
  };

  const pollWebhookResponse = (reqId) => {
    setPolling(true);
    const interval = setInterval(async () => {
      try {
        const res = await axios.get(
          `https://digilocker.myearth.id/api/digilocker/fetch/${reqId}`,
          {
            headers: {
              'app-id': APP_ID,
              'x-api-key': API_KEY,
            },
          }
        );

        if (res.data.status === 'COMPLETED') {
          setResponseData(res.data.data);
          Swal.fire({
            icon: 'success',
            title: 'Success!',
            text: 'KYC verification completed successfully!',
            confirmButtonColor: '#3085d6',
          });
          clearInterval(interval);
          setPolling(false);
        }
      } catch (err) {
        console.log('Polling error:', err?.response?.data?.message || err.message);
      }
    }, 3000);
  };

  return (
    <div className="digilocker-container">
      <h2>🔐 Aadhaar KYC with Digilocker</h2>

      <button className="launch-btn" onClick={handleLaunch} disabled={loading || polling}>
        {loading ? 'Initializing...' : 'Launch Digilocker'}
      </button>

      {requestId && (
        <p className="request-id">Request ID: <code>{requestId}</code></p>
      )}

      {polling && <p className="polling-text">⏳ Waiting for KYC to complete...</p>}

      {responseData && (
        <div className="response-box">
          <h3>📄 KYC Response</h3>
          <pre>{JSON.stringify(responseData, null, 2)}</pre>
        </div>
      )}
    </div>
  );
};

export default DigilockerLauncher;
